import { render, staticRenderFns } from "./MultiWhatsappChannels.vue?vue&type=template&id=550aae8a&scoped=true"
import script from "./MultiWhatsappChannels.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannels.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannels.vue?vue&type=style&index=0&id=550aae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550aae8a",
  null
  
)

export default component.exports